import { Link } from "react-router-dom";
import React from "react";
import { Button } from "react-bootstrap";
import usePageTitle from "common/usePageTitle";

function MaturaApplicationSentPage() {
  usePageTitle("Prijava uspješno poslana");

  return (
    <div>
      <h1 className="text-center">Prijava uspješno poslana!</h1>
      <hr />
      <p className="text-center">
        Zahvaljujemo na prijavi. Ubrzo ćemo Vas kontaktirati.
      </p>
      <hr />
      <div className="text-center mt-5">
        <Link to="/">
          <Button variant="primary">Povratak na naslovnu stranicu</Button>
        </Link>
      </div>
    </div>
  );
}

export default MaturaApplicationSentPage;
